import TrueStrikeZone from "./TrueStrikeZone.js";

/**
 * This is the strike zone boundary dimensions and location drawn to the rulebook for a typical 73-inch-tall player,
 * with the added half-ball width added to the perimeter. Because if the center of the ball lands with half its width outside the strike zone boundary,
 * the ball’s outer edge touches the zone. This is the universal strike zone used for postgame analysis when the batter height is not known.
 * If the center of the ball is in this zone, it is a strike.
 * more @ https://www.baseballprospectus.com/news/article/40891/prospectus-feature-the-universal-strike-zone/
 *      @ https://docs.google.com/document/d/1AP6qx2Y64D2CwIlOF_XzgDcUWDWQLfI1TCCBGx0GDko/edit#
 *      @ https://www.baseballprospectus.com/wp-content/uploads/2018/06/universal2-768x818.png
 */
class UniversalStrikeZonePG extends TrueStrikeZone{
    constructor(){
        const strikeZoneBottom = 19.76 * 0.0254;
        const strikeZoneTop = 42.61 * 0.0254;
        const ballSize = 2.94 * 0.0254;
        const homePlateWidth = 17 * 0.0254;

        super(ballSize, homePlateWidth, strikeZoneBottom, strikeZoneTop);
    }
}

export default UniversalStrikeZonePG;